<script lang="ts">

    import { onDestroy, onMount } from 'svelte';
    import {  ToastProperties, storeNotification, emptyNotification } from "../js/toaster";
    import Toast from "./Toast.svelte";
    import { english } from "../store/store";

    let itemsBottomLeft: ToastProperties[] = [];

    onMount(async () => {
        const notificationPropertieFR: ToastProperties = {
            message: "Jetez un oeil à nos projets !",
            level: ""
        }
        const notificationPropertieEN: ToastProperties = {
            message: "Take a look at our projects!",
            level: ""
        }
        storeNotification.set(notificationPropertieFR);
        const unsubscribe = english.subscribe((englishValue) => {
            if (englishValue) {
                storeNotification.set(notificationPropertieEN);           
            } else {
                storeNotification.set(notificationPropertieFR);
            }
        });
	});

    onDestroy(() => {
        storeNotification.set(emptyNotification);
    });

</script>

<style lang="scss">

    .toaster {
        margin: 0px 40px 0px 40px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        &__buttons {
            display: flex;
            flex-direction: row;
            &__button {
                margin: 0px 12px 0 12px;
                border: 1px solid lightgrey;
                padding: 4px 4px 4px 4px;
                button {
                    cursor: pointer;
                }
            }
        }
    }

    .toastsBottomLeft {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        position: fixed;
        z-index: 10000;
        left: auto;
        right: auto;
        bottom: 30px;
    }

</style>

<div class="toaster">
    <div class="toastsBottomLeft">
        <Toast props={itemsBottomLeft[0]} />
    </div>    
</div>
